import React from 'react';

const User = () => {
  const login = () => {
    if (typeof window !== 'undefined') {
      const redirectUrl = 'https://docs.silabs.com/api/v2/login-redirect';
      const clientId =
        '3MVG9yZ.WNe6byQBECTQsIW3LXKhYn_soJgXLIpSZnXDh6T60o8stVMVX0CW2faTFXJhe8sG4WWqW.KSVaxBD';
      const provider = 'https://community.silabs.com';
      window.location.href = `${provider}/services/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code`;
    }
  };
  const readStorageValue = (value: string) => {
    if (typeof window !== 'undefined') {
      const data = window.sessionStorage.getItem('silabsprofile');
      let storageValue = '';
      if (data) {
        const values = data.split('|');
        let i = 0;
        for (; i < values.length; i++) {
          // eslint-disable-next-line @typescript-eslint/prefer-includes
          if (values[i].indexOf(value) > -1) {
            storageValue = values[i].split('=')[1];
            break;
          }
        }
      }
      return storageValue;
    }
    return '';
  };
  const logout = () => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem('silabsprofile');
      window.location.href =
        'https://community.silabs.com/apex/SL_Logout?LOF=Docs';
    }
  };
  const clientProfile = readStorageValue('FirstName');

  const accountHome = () => {
    window.location.href = 'https://community.silabs.com/s';
  };

  return (
    <>
      <button>
        <img src="/assets/images/icons/user.svg" alt="Silabs Login" />
      </button>
      {!clientProfile && (
        <ul className="nav__submenu">
          <li>
            <a
              href="#page-header"
              className="nav__submenu-item"
              onClick={login}
            >
              Login
            </a>
          </li>
          <li>
            <a
              className="nav__submenu-item"
              href="https://community.silabs.com/SL_CommunitiesSelfReg"
            >
              Register
            </a>
          </li>
        </ul>
      )}
      {clientProfile && (
        <ul className="nav__submenu">
          <li>
            <span className="nav__submenu-item">
              Welcome&#44;&#32;{clientProfile}
            </span>
          </li>
          <li>
            <span
              role="button"
              className="nav__submenu-item link"
              tabIndex={0}
              onClick={accountHome}
              onKeyDown={(e) => e.key === 'Enter' && accountHome()}
            >
              Account Home
            </span>
          </li>
          <li>
            <a
              href="#page-header"
              className="nav__submenu-item"
              onClick={logout}
            >
              Logout
            </a>
          </li>
        </ul>
      )}
    </>
  );
};

export default User;
